<template>
  <div id="InstitutionList" class="institutions-list">
    <VueSkeletonLoader class="doctors-list-title" :width="300" :height="34" />
    <div class="doctors-list-columns two-columns">
      <div v-for="i in 5" :key="i">
        <InstitutionListCardSkeleton />
      </div>
    </div>
  </div>
</template>

<script>
import VueSkeletonLoader from "skeleton-loader-vue";

import InstitutionListCardSkeleton from "./InstitutionListCardSkeleton.vue";

export default {
  name: "InstitutionListSkeleton",
  components: {
    VueSkeletonLoader,
    InstitutionListCardSkeleton
  }
};
</script>
